module.exports = __webpack_public_path__ + "img/banner_h501.e22b0ad6.webp";